import {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import PageLoader from '../../../../components/pageLoader';
import useGetListLoanRequest from '../../../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import FAQAccordions from './components/FAQAccordions';
import StoreContracts from './components/StoreContracts';
import SelectRequestTypeBtm from './SelectRequestTypeBtm';

const StartLoanCreditPage = () => {
  const navigate = useNavigate();
  const [showRequestTypeBtm, setIsShowRequestTypeBtm] = useState(false);
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);
  const bottomRef = useRef<HTMLDivElement>(null);

  const {state} = useLocation() as {state: {show404Toast: boolean}};

  const {
    data: listLoanRequest,
    isLoading: isLoadingListLoanRequest,
    isFetching,
    isFetched,
  } = useGetListLoanRequest({is_finished: false}, 'no-cache');

  useEffect(() => {
    if (!state?.show404Toast) return;
    toast.error(
      'شما سفارشی در فروشگاه طرف قرار داد ندارید لطفا ابتدا سفارش خود را در فروشگاه های طرف قرار ثبت کنید ',
    );
  }, []);

  // Scroll to bottom on page load
  useEffect(() => {
    bottomRef.current?.scrollIntoView({behavior: 'smooth'});
  }, []);

  useEffect(() => {
    if (!isFetched || isFetching || isLoadingListLoanRequest) return;

    if (listLoanRequest?.guid) {
      navigate('/my-credits', {replace: true, state: {hasLoanRequest: true}});
    }
  }, [
    listLoanRequest,
    navigate,
    isLoadingListLoanRequest,
    isFetched,
    isFetching,
  ]);

  if (isLoadingListLoanRequest) return <PageLoader />;

  return (
    <div className="flex flex-col w-full min-h-full bg-white">
      {/* ---------------- HEADER ---------------- */}
      <CustomHeader
        sticky={true}
        preComponent={() => (
          <div
            className="flex relative gap-2 items-center cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">دریافت اعتبار</span>
          </div>
        )}
        postComponent={() => (
          <div className="flex gap-3">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />

      {/* ---------------- CONTENT ---------------- */}
      <div className="flex flex-col flex-1 px-6 py-3 w-full">
        <p className="text-sm leading-relaxed text-gray-600">
          در این قسمت می‌توانید سوالات پر تکرار خود را مشاهده کنید
        </p>

        <p className="mt-2 text-md font-Medium text-gray-950">
          سوالات پر تکرار
        </p>

        <FAQAccordions
          openAccordion={openAccordion}
          setOpenAccordion={setOpenAccordion}
        />

        <StoreContracts />

        {/* Empty div as scroll target */}
        <div ref={bottomRef} />
      </div>

      {/* Footer Buttons */}
      <div className="flex sticky bottom-1 z-50 flex-col gap-2 bg-white">
        <div className="flex flex-col gap-2 px-6">
          <button
            type="button"
            className="w-full h-12 bg-white rounded-lg border-2 text-farm-shop-500 border-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700"
            onClick={() => navigate('/loan-payment-calculator')}
          >
            محاسبه گر
          </button>

          <button
            type="button"
            onClick={() => setIsShowRequestTypeBtm(true)}
            className="w-full h-12 text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700"
          >
            درخواست وام
          </button>
        </div>
        <MainFooter isScrolling={false} />
      </div>

      <SelectRequestTypeBtm
        isOpen={showRequestTypeBtm}
        setIsOpen={setIsShowRequestTypeBtm}
      />
    </div>
  );
};

export default StartLoanCreditPage;
